<div class="container">
  <div class="row">
    <div class="col-md-8 col-lg-6 mx-auto">
      <form [formGroup]="changePinForm" class="changePinForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="password" class="pin-label">New Memorable Number</label>
          <input type="password" name="password" class="form-control content-input" formControlName="pin" maxlength=6 [ngClass]="{
              'is-valid': pinCtrl.valid && !wrongPin && !changePinForm.hasError('pinnotmatch'),
              'is-invalid': ((!pinCtrl.valid || wrongPin) && pinCtrl.touched) || (changePinForm.hasError('pinnotmatch') && pinCtrl.valid && confirmPinCtrl.value)
            }" (keypress)="$event.charCode >= 48 && $event.charCode <= 57 || $event.charCode === 0">
          <div class="error-message" *ngIf="pinCtrl.touched && pinCtrl.hasError('required')">
            Please enter valid information here.
          </div>
          <div class="error-message" *ngIf="pinCtrl.touched && (wrongPin || pinCtrl.hasError('minlength') || pinCtrl.hasError('maxlength'))">
            Memorable Number has 6 numeric characters and no repetition or sequencing.
          </div>
        </div>

        <div class="form-group">
          <label for="confirm-password" class="pin-label">Confirm New Memorable Number</label>
          <input type="password" name="confirm-password" class="form-control content-input" formControlName="pinConfirm" maxlength=6
            autocomplete="off" [ngClass]="{
              'is-valid': confirmPinCtrl.touched && !changePinForm.hasError('pinnotmatch'),
              'is-invalid': pinCtrl.valid && changePinForm.hasError('pinnotmatch')  && confirmPinCtrl.touched
            }" (keypress)="$event.charCode >= 48 && $event.charCode <= 57 || $event.charCode === 0" npDetectFocus #ipConfirmPin="detectFocus">

          <div class="error-message" *ngIf="!confirmPinCtrl.value && confirmPinCtrl.touched && pinCtrl.valid && !wrongPin">
            Please confirm your memorable number
          </div>
          <div class="error-message" *ngIf="confirmPinCtrl.value && changePinForm.hasError('pinnotmatch') && pinCtrl.valid && !wrongPin">
            Memorable number and Confirm memorable number do not match
          </div>
        </div>

        <div class="form-group">
          <button class="btn btn-block" type="submit" [ngClass]="{
            'btn-greengo': changePinForm.valid && !wrongPin,
            'btn-inactive': !changePinForm.valid || wrongPin
          }" npFocusOutClicked>Save</button>
        </div>
      </form>
    </div>
  </div>
</div>